import {
  Component
} from '@angular/core';
import { StickyObserverComponent } from '../observer/sticky-observer.component';

@Component({
  selector: 'td-wb-sticky-panel-bottom',
  templateUrl: 'sticky-panel-bottom.component.html',
  styleUrls: ['sticky-panel-bottom.component.scss'],
  imports: [
    StickyObserverComponent
  ],
  host: {
    '[class.td-wb-sticky-panel-bottom--sticky]': 'sticky'
  }
})

export class StickyPanelBottomComponent {
  sticky: boolean;

  stickyStateChange(state: boolean): void {
    this.sticky = state;
  }
}
